import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { CustomersLoveSection } from '@/components/vets/CustomersLoveSection';
import { FeaturesSection } from '@/components/vets/FeaturesSection';
import { GoodForWorldSection } from '@/components/vets/GoodForWorldSection';
import { GoodToKnowSection } from '@/components/vets/GoodToKnowSection';
import { Hero } from '@/components/vets/Hero';
import { config } from '@/pageConfig/vets/en';
import { Box } from '@lemonade-hq/cdk';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function VetsPage() {
  const { trackEvent } = useAnalyticsContext();

  useEffect(() => {
    trackEvent('vet_landing_page_view');
  }, []);

  return (
    <Box position="relative" overflowX="hidden">
      <Layout headerActions={config.layout.headerActions} headerBanner={config.headerBanner} pt={[130, 100, 140]}>
        <SEO {...config.seo} />
        <PageWrapper>
          <Hero {...config.hero} />
          <FeaturesSection {...config.featuresSection} />
          <CustomersLoveSection {...config.customersLoveSection} />
          <FeaturesSection {...config.coverageInfoSection} />
          <GoodForWorldSection {...config.goodForWorldSection} />
          <GoodToKnowSection {...config.goodToKnowSection} />
        </PageWrapper>
      </Layout>
    </Box>
  );
}
